import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AddSimpleIcon,
  Block,
  CheckIcon,
  DeleteIcon,
  FlexRow,
  HiddenField,
  IconButton,
  MyInfoIcon,
  SmallGrayText,
  SmallText,
  TextBox,
  ToolTipHover,
} from '@guryou/html-components';

const SelectStaff = () => {
  const { t } = useTranslation();
  const [staff, setStaff] = useState([]);
  const [singleStaff, setSingleStaff] = useState('');

  const handleAddStaff = () => {
    if (singleStaff && staff.length <= 2) {
      setStaff(prev => [...prev, { id: Date.now(), name: singleStaff }]);
      setSingleStaff('');
    }
  };

  const handleRemoveStaff = id => {
    setStaff(prevItems => prevItems.filter(item => item.id !== id));
  };
  return (
    <Block margin={0}>
      <Block margin={0} display="flex" flexDirection="row" alignItems="start" justifyContent="start">
        <SmallGrayText marginRight={2}>{t('ONBOARD.addStaffNames')}</SmallGrayText>
        <ToolTipHover textAlign="left" cleanToolTip={true} label={<MyInfoIcon fontSize="small" />} text={t('ONBOARD.youCanAddMoreLater')} />
      </Block>
      {staff?.map((x, index) => (
        <Block key={x.id} display="flex" flexDirection="row" alignItems="center" margin={0} marginBottom={index === 1 ? 4 : 0}>
          <Block borderBottom="1px solid green" padding={0.5} margin={0}>
            <FlexRow margin={0} alignItems="center">
              <CheckIcon htmlColor="green" />
              <SmallText marginLeft={1} color="green" overflow="hidden">
                {x.name}
              </SmallText>
              <HiddenField name="staffNames" value={x.name} />
            </FlexRow>
          </Block>
          {/* <TextBox value={x.name} readOnly={true} name="staffNames" fullWidth margin="0px 0px 20px 0px"></TextBox> */}
          <IconButton icon={DeleteIcon} label={t('ONBOARD.remove')} onClick={() => handleRemoveStaff(x.id)} />
        </Block>
      ))}
      {staff.length <= 1 && (
        <Block display="flex" flexDirection="row" alignItems="center" margin={0} marginBottom={4}>
          <TextBox
            key={staff.length}
            fullWidth
            placeholder={t('ONBOARD.enterStaffName')}
            value={singleStaff}
            onChange={val => setSingleStaff(val)}
            margin="0px 0px 20px 0px"
          ></TextBox>
          <IconButton icon={AddSimpleIcon} label={t('ONBOARD.add')} onClick={() => handleAddStaff(prev => !prev)} />
        </Block>
      )}
    </Block>
  );
};

export default SelectStaff;
